export const safeCurrencyFormat = (amount, currency = "USD") => {
    try {
        return new Intl.NumberFormat("en-NG", {
            style: "currency",
            currency,
            currencyDisplay: "symbol",
            minimumFractionDigits: 2,
        }).format(amount);
    } catch (e) {
        // For unsupported currencies like USDT/USDC
        return `${amount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })} ${currency}`;
    }
};
